import { IconButton, MimaButton, MimaText, Modal } from "../../components";
import { Formik } from "formik";

const EditCatalogueModal = ({
  closeModal,
  onSubmit,
  validationSchema,
  loading,
  initialValues,
  renderStep,
  currentStep,
  setCurrentStep,
}) => {
  const stepTitles = [
    "General Product Information",
    "Product Pricing & Variations",
    "Images & Delivery",
  ];

  const goBack = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" mb={4} width={38} align="center">
        Edit Catalogue
      </MimaText>

      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({
          handleBlur,
          handleChange,
          setFieldValue,
          values,
          errors,
          touched,
          handleSubmit,
        }) => (
          <div style={{ width: "38rem" }}>
            <MimaText align="center" mb={2}>
              {stepTitles[currentStep - 1]}
            </MimaText>
            {currentStep > 1 && (
              <div
                onClick={goBack}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  margin: "2rem 0",
                }}
              >
                <IconButton variant="back" />{" "}
                <MimaText variant="small" ml={-1.5}>
                  Go Back
                </MimaText>
              </div>
            )}

            {renderStep(
              currentStep,
              values,
              handleChange,
              handleBlur,
              errors,
              touched,
              setFieldValue,
            )}

            <MimaButton
              title={currentStep < 3 ? "Continue" : "Edit style"}
              type="submit"
              onClick={handleSubmit}
              width={38}
              buttonColor="var(--color-admin)"
              loading={loading}
              mt={2}
            />
          </div>
        )}
      </Formik>
    </Modal>
  );
};

export default EditCatalogueModal;
